import DataProtectionFormSection from "./sections/DataProtectionFormSection";
import EntityDetailsFormSection from "./sections/EntityDetailsFormSection";
import OwnershipFormSection from "./sections/OwnershipFormSection";
import ProductsServicesFormSection from "./sections/ProductsServicesFormSection";
import RegulatorFormSection from "./sections/RegulatorFormSection";
import SanctionsAndMonitoringFormSection from "./sections/SanctionsAndMonitoringFormSection";
import TravelRuleImplFormSection from "./sections/TravelRuleImplFormSection";
import TravelRulePoliciesFormSection from "./sections/TravelRulePoliciesFormSection";

export const formSections = {
  Ownership: [OwnershipFormSection, RegulatorFormSection],
  TravelRule: TravelRuleImplFormSection,
  Services: ProductsServicesFormSection,
  CddKyc: TravelRulePoliciesFormSection,
  DataProtection: DataProtectionFormSection,
  SanctionScreening: SanctionsAndMonitoringFormSection,
  BlockchainAnalytics: null,
};

export const formTitles = {
  Ownership: "Ownership structure",
  TravelRule: "Travel Rule Data & Requirements",
  Services: "Services",
  CddKyc: "Customer Due Diligence & KYC",
  DataProtection: "Data Protection",
  SanctionScreening: "Sanction Screening",
  BlockchainAnalytics: "Blockchain Analytics",
};

export const formSectionsPerPage = [
  [EntityDetailsFormSection],
  [OwnershipFormSection, RegulatorFormSection],
  [ProductsServicesFormSection],
  [TravelRulePoliciesFormSection],
  [SanctionsAndMonitoringFormSection],
  [DataProtectionFormSection, TravelRuleImplFormSection],
];

export const ddqDescriptionText =
  "This Questionnaire is adapted from the GDF Travel Rule Data Sharing Questionnaire (TRIXO) and the GDF Due Diligence Questionnaire for VASPs. The purpose of this questionnaire is to provide a common set of questions VASPs can ask other VASPs with whom they are planning to begin exchanging Travel Rule information. It is not intended to be a due diligence questionnaire for onboarding other VASPSs as customers.";
